// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type IsEqualTo from "../contract/IsEqualTo";

export default function isEqualTo(data: IsEqualTo): IsEqualTo {
    const result: IsEqualTo = {
        __type: "IsEqualTo:#Exchange",
        ...data,
    };
    
    return result;
}
